/* src/app/layout/layout.component.scss */
main {
  margin: 0 25px;
}
main > div {
  max-width: 1480px;
  margin: 0 auto;
}
main > div > div {
  margin-left: 17rem;
}
/*# sourceMappingURL=layout.component.css.map */
